<template>
  <div class="flex items-center">
    <vs-avatar :src="params.data.avatar_path" class="flex-shrink-0 mr-2" size="30px" @click="$router.push(url)" />
    <router-link :to="url" @click.stop.prevent class="text-inherit hover:text-primary">{{ params.value }}</router-link>
  </div>
</template>

<script>
    export default {
        name: 'CellRendererLink',
        computed: {
          url() {
            // Below line will be for actual product
            // Currently it's commented due to demo purpose - Above url is for demo purpose
            return "/users/splitted/" + this.params.data.username
          }
        }
    }
</script>
